export default "__VITE_ASSET__74b607e3__"